import { render, staticRenderFns } from "./DocDesign.vue?vue&type=template&id=bd4c66d8&scoped=true&"
import script from "./DocDesign.vue?vue&type=script&lang=js&"
export * from "./DocDesign.vue?vue&type=script&lang=js&"
import style0 from "./DocDesign.vue?vue&type=style&index=0&id=bd4c66d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4c66d8",
  null
  
)

export default component.exports